import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgSrc } from "@/lib/api";

export default function ImageUpload({ value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) return toast.error("Ukuran gambar maksimal 8 MB");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/uploads", fd);
      onChange(r.data.url);
      toast.success("Foto terunggah");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="relative h-24 w-24 shrink-0 overflow-hidden rounded-xl border border-dashed border-stone-300 bg-stone-50">
        {value ? <img src={imgSrc(value)} alt="Foto menu" className="h-full w-full object-cover" data-testid="menu-image-preview" /> : <Camera className="absolute inset-0 m-auto h-7 w-7 text-stone-300" />}
        {busy && <div className="absolute inset-0 grid place-items-center bg-white/70"><Loader2 className="h-6 w-6 animate-spin text-orange-600" /></div>}
      </div>
      <div className="space-y-2">
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="menu-image-file-input" />
        <button type="button" data-testid="menu-image-upload-btn" disabled={busy} onClick={() => ref.current?.click()} className="flex items-center gap-2 rounded-lg border border-orange-300 bg-orange-50 px-3 py-2 text-sm font-semibold text-orange-700 hover:bg-orange-100 active:scale-95">
          <Camera className="h-4 w-4" />{value ? "Ganti Foto" : "Ambil / Pilih Foto"}
        </button>
        {value && (
          <button type="button" data-testid="menu-image-remove-btn" onClick={() => onChange("")} className="flex items-center gap-1 text-xs text-red-600 hover:underline"><X className="h-3 w-3" />Hapus foto</button>
        )}
        <p className="text-[11px] text-zinc-400">JPG / PNG / WEBP, maks 8 MB</p>
      </div>
    </div>
  );
}
